import logger from '@/modules/logger/constants/logger';
import { create } from 'zustand';

const useUpdateLock = create<{
  isLocked: boolean;
  lockUpdate: () => void;
  unlockUpdate: () => void;
}>((set) => ({
  isLocked: false,
  lockUpdate: () => {
    logger.debug('core.app', 'Locking the update check process');
    set({ isLocked: true });
  },
  unlockUpdate: () => {
    logger.debug('core.app', 'Unlocking the update check process');
    set({ isLocked: false });
  },
}));

export default useUpdateLock;
